import React from 'react';
import { Link } from 'react-router-dom';
import { Target } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FitnessKids() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1443">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1444">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1445">
          <div data-id="element-1446">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1447">
              <Target className="w-4 h-4" data-id="element-1448" />
              Kids Programs
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1449">
              Fitness, Focus, and Confidence for Kids
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1450">
              In an era of screens and sedentary habits, Storm Taekwondo gets
              kids moving. But the physical fitness is only half the story.
            </p>
            <p className="text-lg text-gray-warm mb-8" data-id="element-1451">
              As they build coordination, balance, and strength, they are
              simultaneously developing crucial life skills: discipline to
              follow instructions, focus to master techniques, and the
              confidence that comes from achieving their goals.
            </p>
            <Link to="/karate-kids-classes.html" className="btn-primary" data-id="element-1452">
              Explore Kids Classes
            </Link>
          </div>
          <div data-id="element-1453">
            <img src={SITE_IMAGES.kidsClasses} alt="Kids Taekwondo fitness" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1454" />
          </div>
        </div>
      </div>
    </section>;
}